import React, { useContext } from "react";
import { CONSTANTS, useTranslate } from "../../helpers";
import { GetStartedIcon } from "./GetStartedIcon";
import { AppStore } from "../../app/store";
import { AnalyticsActionType } from "../../app/contexts/Analytics/types";
import { useFlags, useLDClient } from "launchdarkly-react-client-sdk";
import classnames from "classnames";
import { trackLdEvent } from "../../helpers/launchDarklyHelpers";
interface GetStartedProps {
  id: string;
}

export const GetStarted = ({ id }: GetStartedProps) => {
  const t = useTranslate();
  const { state, dispatch } = useContext(AppStore.AppContext);
  const getStartedUrl = CONSTANTS.linkToGetStartedWithMedicare(state.language);
  const getStartedText = t("landing_page.get_started");
  const flags = useFlags();
  const { tmpFeEnableTestAbVariation } = flags;
  const ldClient = useLDClient();

  return (
    <div className="mct-c-get-started" id={id}>
      <GetStartedIcon className="ds-u-font-size--xl"></GetStartedIcon>
      <div className="ds-u-margin-left--1">
        <p className="ds-u-margin-y--0">
          {t("landing_page.get_started.dont_have_medicare")}
        </p>
        <p
          className={classnames("ds-u-margin-y--0", {
            "ds-u-font-size--lg": tmpFeEnableTestAbVariation,
          })}
        >
          <a
            href={getStartedUrl}
            onClick={() => {
              trackLdEvent({
                ldClient,
                eventName: "landing_page.link_click.get_started_with_medicare",
              });

              dispatch({
                type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
                settings: {
                  linkText: getStartedText,
                  linkUrl: getStartedUrl,
                },
              });
            }}
          >
            {getStartedText}
          </a>
        </p>
      </div>
    </div>
  );
};
